import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../api_config";
import UserContext from "../../Components/Authcontext";
import Load from "../Loading/Load";
import "./modern-forms.css";

function ModernHabitsDetails() {
  const { user, token } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [home, setHome] = useState("");
  const [land, setLand] = useState("");
  const [plat, setPlat] = useState("");
  const [food, setFood] = useState("");
  const [smoking, setSmoking] = useState("");
  const [drinking, setDrinking] = useState("");

  const navigate = useNavigate();

  // Define the form steps
  const totalSteps = 8;
  const currentStep = 6;

  // Calculate progress percentage
  const progressPercentage = (currentStep / totalSteps) * 100;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const response = await axios.post(
      `${API_BASE_URL}/api/HabitDetails`,
      {
        user,
        home,
        land,
        plat,
        food,
        smoking,
        drinking,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );
    if (response.data.auth) {
      setLoading(false);
      navigate("/modern-religious-info", { replace: true });
      setHome("");
      setLand("");
      setPlat("");
      setFood("");
      setSmoking("");
      setDrinking("");
    }
  };

  return loading ? (
    <Load />
  ) : (
    <div className="profile-form-container">
      <div className="decoration decoration-1"></div>
      <div className="decoration decoration-2"></div>
      <div className="decoration decoration-3"></div>
      <div className="decoration decoration-4"></div>
      <div className="profile-form-card">
        {/* Form Header with Progress Bar */}
        <div className="profile-form-header">
          <div className="progress-container">
            <div className="progress-steps">
              {Array.from({ length: totalSteps }, (_, i) => (
                <div key={i} className="progress-step">
                  <div
                    className={`step-number ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 < currentStep ? "\u2713" : i + 1}
                  </div>
                  <div
                    className={`step-label ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 === 1 && "Basic Info"}
                    {i + 1 === 2 && "Contact"}
                    {i + 1 === 3 && "Personal"}
                    {i + 1 === 4 && "Photos"}
                    {i + 1 === 5 && "Family"}
                    {i + 1 === 6 && "Lifestyle"}
                    {i + 1 === 7 && "Religious"}
                    {i + 1 === 8 && "Preferences"}
                  </div>
                </div>
              ))}
              <div className="progress-line">
                <div
                  className="progress-line-fill"
                  style={{ width: `${progressPercentage}%` }}
                ></div>
              </div>
            </div>
          </div>
          <h2 className="profile-form-title">Lifestyle & Assets</h2>
          <p className="profile-form-subtitle">Tell us about your lifestyle preferences</p>
          <p className="required-fields-note">All fields are mandatory</p>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit}>
          <div className="profile-form-body">
            <div className="form-section-title">Assets</div>
            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Own House</label>
                  <select
                    className="form-control"
                    value={home}
                    onChange={(e) => setHome(e.target.value)}
                    required
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Own Land/Plot</label>
                  <select
                    className="form-control"
                    value={land}
                    onChange={(e) => setLand(e.target.value)}
                    required
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Agricultural Land</label>
              <select
                className="form-control"
                value={plat}
                onChange={(e) => setPlat(e.target.value)}
                required
              >
                <option value="">Select option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            <div className="form-section-title">Lifestyle Preferences</div>
            <div className="form-group">
              <label className="form-label">Food Preference</label>
              <select
                className="form-control"
                value={food}
                onChange={(e) => setFood(e.target.value)}
                required
              >
                <option value="">Select food preference</option>
                <option value="Vegetarian">Vegetarian</option>
                <option value="Non-Vegetarian">Non-Vegetarian</option>
                <option value="Eggetarian">Eggetarian</option>
                <option value="Vegan">Vegan</option>
                <option value="Any">Any</option>
              </select>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Smoking Habit</label>
                  <select
                    className="form-control"
                    value={smoking}
                    onChange={(e) => setSmoking(e.target.value)}
                    required
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Occasionally">Occasionally</option>
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Drinking Habit</label>
                  <select
                    className="form-control"
                    value={drinking}
                    onChange={(e) => setDrinking(e.target.value)}
                    required
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Occasionally">Occasionally</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Form Footer with Buttons */}
          <div className="profile-form-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={() => navigate("/modern-family-info")}
            >
              Back
            </button>
            <button type="submit" className="btn btn-primary">
              Save & Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModernHabitsDetails;
